import styles from "../detalheEsocial.styles.module.css";
import { gruposExibidos } from "./CabecalhoRubricas";

function celulaOuTraco(valor) {
  if (valor == null || String(valor).trim() === "") return "—";
  return String(valor);
}

/**
 * TXM-671 — células de incidência (INSS/FGTS/IRRF) de uma rúbrica, só dos grupos exibidos
 * e na mesma ordem do cabeçalho. Retorna `<td>`s soltos: precisa ficar dentro de um `<tr>`.
 *
 * @param {{ r: object, gruposAtivos: string[] }} props `r` = rúbrica enriquecida
 *   (enriquecerRubricas), com os campos `inss*`, `fgts*` e `irrf*`.
 */
export default function CelulasIncidenciaRubrica({ r, gruposAtivos }) {
  return gruposExibidos(gruposAtivos).flatMap((grupo) =>
    grupo.colunas.map((coluna, i) => {
      const texto = celulaOuTraco(r[coluna.chave]);
      // cor do grupo (como no protótipo) + divisória na 1ª coluna de cada grupo
      const classes = [
        coluna.chave.endsWith("Codigo") ? styles.rubricaCod : "",
        styles[`celGrupo_${grupo.id}`],
        i === 0 ? styles.celGrupoPrimeira : "",
      ]
        .filter(Boolean)
        .join(" ");
      return (
        <td key={coluna.chave} className={classes} title={texto}>
          {texto}
        </td>
      );
    })
  );
}
